import { BasicRequest } from "./basicRequest";

export class ResolveMoovInstanceCollisionRequest extends BasicRequest{
    
    public collisionId!:string;

    constructor(){
        super();
    }
}